import React from 'react';
import styles from './TableContainer.module.css';
import OrdersTable from './OrdersTable';
import StatsTable from './StatsTable';

interface TableContainerProps {
	showTable: boolean;
	clientId: number;
	selectedMonth?: string;
	tableType: 'orders' | 'activities';
}

const TableContainer: React.FC<TableContainerProps> = ({
	showTable,
	clientId,
	selectedMonth,
	tableType,
}) => {
	const tableComponent = tableType === 'orders' ? (
		<OrdersTable
			clientId={clientId}
			selectedMonth={selectedMonth}
			showTable={showTable}
		/>
	) : (
		<StatsTable
			clientId={clientId}
			selectedMonth={selectedMonth}
			showTable={showTable}
		/>
	);

	// Если таблица не показана или пустая, не рендерим контейнер
	if (!showTable || !tableComponent) {
		return null;
	}

	return (
		<div className={styles.tableContainer}>
			{tableComponent}
		</div>
	);
};

export default TableContainer;
